import { clsx } from 'clsx';
import type { CollaboratorVacationSummary } from '@/features/Collaborators/Models/collaborator.types';
import { buildVacationAllocationLabel } from '@/features/Vacations/utils/vacationAllocationLabel';

interface VacationBadgeProps {
    summary: CollaboratorVacationSummary | null | undefined;
    allocationId?: string | null;
    className?: string;
}

const VACATION_TONE_CLASSES: Record<string, string> = {
    success: 'border-green-200 bg-green-50 text-green-900',
    warning: 'border-yellow-200 bg-yellow-50 text-yellow-900',
    danger: 'border-red-200 bg-red-50 text-red-900',
    primary: 'border-indigo-200 bg-indigo-50 text-indigo-900',
    neutral: 'border-gray-200 bg-gray-50 text-gray-700',
};

export const VacationBadge: React.FC<VacationBadgeProps> = ({ summary, allocationId, className }) => {
    const vacationLabel = buildVacationAllocationLabel(summary, { allocationId });

    if (!vacationLabel) return null;

    return (
        <div
            className={clsx(
                'rounded-xl border p-3 text-xs font-medium',
                VACATION_TONE_CLASSES[vacationLabel.tone],
                className
            )}
        >
            <span className="font-semibold">Férias:</span> <span>{vacationLabel.text}</span>
        </div>
    );
};
